export default "__VITE_ASSET__20blyWKs__"